Object.defineProperty(exports,"__esModule",{value:true});var ImageResizeMode={center:'center',contain:'contain',cover:'cover',none:'none',repeat:'repeat',stretch:'stretch'};exports.default=ImageResizeMode;


// WEBPACK FOOTER //
// ./node_modules/react-native-web/dist/components/Image/ImageResizeMode.js